import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, memo } from 'react';
import { useHomeCurrency } from '../v2/hooks/useHomeCurrency';
import UICurrencyInput from 'UIComponents/input/UICurrencyInput';
import UINumberInput from 'UIComponents/input/UINumberInput';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { parseNumericValue } from '../utils/parseNumericValue';
import isFractionalCurrencySupported from '../v2/utils/isFractionalCurrencySupported';

const PropertyInputHomeCurrencyV2 = props => {
  const {
    value,
    onChange,
    inputRef,
    multiCurrencyCurrencyCode,
    subjectCurrencyCode,
    objectTypeId
  } = props;
  const {
    data: homeCurrencyCode
  } = useHomeCurrency();
  const currencyCode = multiCurrencyCurrencyCode || subjectCurrencyCode || homeCurrencyCode;
  const handleChange = useCallback(evt => {
    if (typeof onChange === 'function') {
      // UINumberInput and UICurrencyInput's onChange send `number | null`; convert to `string | null`
      onChange(evt.target.value == null ? evt : SyntheticEvent(String(evt.target.value)));
    }
  }, [onChange]);
  const currencyValue = parseNumericValue(value);
  const defaultFractionalCurrencyProps = {
    maxFractionDigits: 6
  };
  const fractionalCurrencyProps = isFractionalCurrencySupported(objectTypeId) ? defaultFractionalCurrencyProps : undefined;
  return !currencyCode ? /*#__PURE__*/_jsx(UINumberInput, Object.assign({}, getTransferrableProps(props), {
    onChange: handleChange,
    inputRef: inputRef // @ts-expect-error UINumberInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue
  })) : /*#__PURE__*/_jsx(UICurrencyInput, Object.assign({}, getTransferrableProps(props), {}, fractionalCurrencyProps, {
    isNativeCurrency: false,
    currency: currencyCode,
    onChange: handleChange,
    inputRef: inputRef // @ts-expect-error UICurrencyInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue
  }));
};

export default /*#__PURE__*/memo(PropertyInputHomeCurrencyV2);